import { FiEdit } from "react-icons/fi";
import { BiUserPin } from "react-icons/bi";
import { HiOutlineCalendar, HiDesktopComputer } from "react-icons/hi";
import { BiLock } from "react-icons/bi";
import React from "react";
import { BsLightning } from "react-icons/bs";

export const ADVANTAGES = [
  {
    icon: <FiEdit />,
    title: "Cadastro fácil",
    description: "Cadastre as informações do seu imóvel",
  },
  {
    icon: <HiOutlineCalendar />,
    title: "Agendamento E-mail",
    description: "Registre um agendamento",
  },
  {
    icon: <BiUserPin />,
    title: "Anunciante",
    description: "Anuncie com mais praticidade",
  },
  {
    icon: <BsLightning />,
    title: "Propostas rápidas",
    description: "Receba e aceite propostas online",
  },
  {
    icon: <HiDesktopComputer />,
    title: "Contrato Online",
    description: "Assine o contrato digitalmente",
  },
  {
    icon: <BiLock />,
    title: "Segurança",
    description: "Cuidamos da segurança da transação",
  },
];
